import { render } from "./BodyError.vue?vue&type=template&id=3cb99725&scoped=true"
import script from "./BodyError.vue?vue&type=script&lang=js"
export * from "./BodyError.vue?vue&type=script&lang=js"

import "./BodyError.vue?vue&type=style&index=0&id=3cb99725&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb99725"]])

export default __exports__